export default __webpack_public_path__ + "static/5-tips-to-maximise-your-free-global-wi-fi-246aeeb1b2c0e183346ac5bb307a2671.jpg";